import React, { useState } from "react";
import { showToast } from "../../Shared/Toaster";
import "../../../css/AddForm.css";
import api from '../../../api/axiosConfig';

interface FormData {
  name: string;
  category: string;
  version: string;
  definition: string;
}

interface AddFormProps {
  onSubmit?: (form: FormData) => void;
}

const AddForm: React.FC<AddFormProps> = ({ onSubmit }) => {
  const [form, setForm] = useState<FormData>({
    name: "",
    category: "QAVACH STAFF",
    version: "",
    definition: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  // const { instance, accounts } = useMsal();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {

      const token = sessionStorage.getItem("accessToken");

      const payload = {
      ...form,
      key: form.name.toUpperCase(), // add key field
    };

      // 📡 API call using Axios
      const res = await api.auth_api.post("/forms", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setMessage("✅ Form created successfully!");
      showToast("Form created successfully ✅", "success");

      if (onSubmit) onSubmit(res.data);

      // reset form
      setForm({
        name: "",
        category: "STAFF",
        version: "",
        definition: "",
      });
    } catch (error: any) {
      console.error("Error submitting form:", error);
      const errMsg = error.response?.data?.message || error.message || "Failed to create form. Please try again.";
      setMessage(`❌ ${errMsg}`);
      showToast(errMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="add-form" onSubmit={handleSubmit}>
      <h2>Add New Form</h2>

      <label>Form Name</label>
      <input
        type="text"
        name="name"
        placeholder="Enter Form name"
        value={form.name}
        onChange={handleChange}
        required
      />

      <label>Category</label>
      <select name="category" value={form.category} onChange={handleChange}>
        {/* <option value="">--select category--</option> */}
        <option value="QAVACH STAFF">Qavach STAFF</option>
        <option value="TELE SPECIALIST">TELE SPECIALIST</option>
        
      </select>

      <label>Version Number</label>
      <input
        type="text"
        name="version"
        placeholder="Enter Version"
        value={form.version}
        onChange={handleChange}
        required
      />

      <label>Details</label>
      <textarea
        name="definition"
        placeholder="Enter details"
        value={form.definition}
        onChange={handleChange}
      />

      <button type="submit" className="create-btn" disabled={loading}>
        {loading ? "Creating..." : "Create Form"}
      </button>

      {message && <p className="form-message">{message}</p>}
    </form>
  );
};

export default AddForm;
